<main class="open-jobs" aria-labelledby="open-jobs-title">
  <header class="open-jobs__header">
    <h1 id="open-jobs-title">{{ "open_jobs_summary_title" | translate }}</h1>
  </header>

  <section class="open-jobs__filters" [attr.aria-label]="'open_jobs_summary_filters' | translate">
    <mat-form-field appearance="outline">
      <mat-label>{{ "open_jobs_summary_filter_site" | translate }}</mat-label>
      <input matInput [(ngModel)]="siteName" [placeholder]="'open_jobs_summary_site_name' | translate" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ "open_jobs_summary_filter_brand" | translate }}</mat-label>
      <mat-select [(ngModel)]="brandName">
        <mat-option value="">{{ "open_jobs_summary_show_all" | translate }}</mat-option>
        @for (brand of brands; track brand) {
          <mat-option [value]="brand">{{ brand }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </section>

  @if (hasLoadError) {
    <div class="open-jobs__state open-jobs__state--error">{{ "open_jobs_summary_load_error" | translate }}</div>
  } @else if (hasLoaded && filteredSummaries.length === 0) {
    <div class="open-jobs__state">{{ "open_jobs_summary_empty" | translate }}</div>
  } @else if (hasLoaded) {
    <section class="open-jobs__table-wrap" [attr.aria-label]="'open_jobs_summary_by_site' | translate">
      <table class="open-jobs__table">
        <thead>
          <tr>
            <th>{{ "open_jobs_summary_site" | translate }}</th>
            <th>{{ "open_jobs_summary_brand" | translate }}</th>
            <th>{{ "open_jobs_summary_new" | translate }}</th>
            <th>{{ "open_jobs_summary_on_site" | translate }}</th>
            <th>{{ "open_jobs_summary_returning" | translate }}</th>
            <th>{{ "open_jobs_summary_awaiting_parts" | translate }}</th>
            <th>{{ "open_jobs_summary_ppm" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (summary of filteredSummaries; track summary.site?.id) {
            <tr>
              <td>{{ getSiteName(summary) || ("open_jobs_summary_unknown_site" | translate) }}</td>
              <td>{{ getBrandName(summary) || ("open_jobs_summary_not_available" | translate) }}</td>
              <td><button type="button" class="job-count" [disabled]="summary.new === 0" (click)="openJobList(summary, 'New', summary.new)">{{ summary.new }}</button></td>
              <td><button type="button" class="job-count" [disabled]="summary.onSite === 0" (click)="openJobList(summary, 'On-Site', summary.onSite)">{{ summary.onSite }}</button></td>
              <td><button type="button" class="job-count" [disabled]="summary.returning === 0" (click)="openJobList(summary, 'Returning', summary.returning)">{{ summary.returning }}</button></td>
              <td><button type="button" class="job-count" [disabled]="summary.awaitingParts === 0" (click)="openJobList(summary, 'Awaiting-Parts', summary.awaitingParts)">{{ summary.awaitingParts }}</button></td>
              <td><button type="button" class="job-count" [disabled]="summary.ppm === 0" (click)="openJobList(summary, 'PPM', summary.ppm)">{{ summary.ppm }}</button></td>
            </tr>
          }
        </tbody>
      </table>
    </section>

    <section class="open-jobs__cards" [attr.aria-label]="'open_jobs_summary_by_site' | translate">
      @for (summary of filteredSummaries; track summary.site?.id) {
        <article class="site-card">
          <header><strong>{{ getSiteName(summary) || ("open_jobs_summary_unknown_site" | translate) }}</strong><span>{{ getBrandName(summary) || ("open_jobs_summary_not_available" | translate) }}</span></header>
          @for (item of [
            { key: 'open_jobs_summary_new', type: 'New', count: summary.new },
            { key: 'open_jobs_summary_on_site', type: 'On-Site', count: summary.onSite },
            { key: 'open_jobs_summary_returning', type: 'Returning', count: summary.returning },
            { key: 'open_jobs_summary_awaiting_parts', type: 'Awaiting-Parts', count: summary.awaitingParts },
            { key: 'open_jobs_summary_ppm', type: 'PPM', count: summary.ppm }
          ]; track item.key) {
            @if (item.count > 0) {
              <div class="site-card__row">
                <span>{{ item.key | translate }}</span>
                <button type="button" class="job-count" (click)="openJobList(summary, item.type, item.count)">{{ item.count }}</button>
              </div>
            }
          }
        </article>
      }
    </section>
  }
</main>